export default __webpack_public_path__ + "static/grenette-italic-pro-05ebfe0e2289ce58b3a8f109078582f9.woff";